// @ts-nocheck
import { createStyle } from '@gluestack-style/react';
import { BaseIconVariants } from './Icon';

export const FormControlErrorIcon = createStyle({
  variants: BaseIconVariants,
  color: '$error700',
  _dark: {
    color: '$error400',
  },
  props: {
    size: 'sm',
  },
});
